import { RouterProvider } from 'react-router-dom';
import { GlobalLayout } from './components/GlobalLayout';
import { ErrorBoundary } from './components/ErrorBoundary';
import { router } from './routes';

export function App() {
  return (
    <ErrorBoundary>
      <GlobalLayout>
        <RouterProvider router={router} />
      </GlobalLayout>
    </ErrorBoundary>
  );
}
